module.exports = __webpack_public_path__ + "img/5.9d6acec2.png";